import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { UnitsList } from '../../../redux/slices/userSlice'
import theme from '../../../theme/theme'
import { useTranslation } from 'react-i18next'

interface UnitsPreferencesProps {
    units: UnitsList[]
    onChangeUnits: (id: string, selected: string) => void
    disabled?: boolean
}

const UnitsPreferences = ({
    units,
    onChangeUnits,
    disabled,
}: UnitsPreferencesProps): ReactElement | null => {
    const { t } = useTranslation()
    if (!units?.length) return null

    return (
        <Box>
            <Typography
                variant="h5"
                component="h2"
                sx={{
                    fontSize: theme.typography.h6,
                    textWrap: 'nowrap',
                    marginBottom: '10px',
                }}
            >
                {t('unitsPreferences')}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '30px',
                }}
            >
                {units?.map((item) => (
                    <Box
                        key={uuidv4()}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                        }}
                    >
                        <Typography
                            sx={{
                                color: '#0009',
                                fontSize: theme.typography.body1.fontSize,
                                fontWeight: theme.typography.body1.fontWeight,
                            }}
                        >
                            {t(`${item.id}`)}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '5px',
                            }}
                        >
                            {item.units?.map((u) => (
                                <Box
                                    key={uuidv4()}
                                    id={u}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '5px 10px',
                                        minWidth: '35px',
                                        height: '30px',
                                        borderRadius: '3px',
                                        border: `${
                                            item.selected === u
                                                ? `2px solid ${theme.palette.primary.main}`
                                                : '1px solid #00000030'
                                        }`,
                                        cursor: disabled
                                            ? 'default'
                                            : 'pointer',
                                        opacity: disabled ? '0.7' : '1',
                                    }}
                                    onClick={
                                        item.selected === u || disabled
                                            ? () => {}
                                            : () => onChangeUnits(item.id, u)
                                    }
                                >
                                    {u || ''}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default UnitsPreferences
